export enum Source {
    PROJECTS_LAUNCH = 'projects_launch',
    CONTESTS_LAUNCH = 'contests_launch',
}



// WEBPACK FOOTER //
// ./js/launch/consts/signupSource.ts